import React from 'react';
import { NyanCat } from 'components/NyanCat';
import { AppPageWrapper } from './AppPageWrapper';

export default function LoadingScreen() {
  return (
    <AppPageWrapper>
      <h1 className={'nes-text'}>Picsel</h1>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '20vh',
        }}
      >
        <NyanCat />
      </div>
    </AppPageWrapper>
  );
}
